const ClockFilled = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5ZM9.75 6C9.75 5.58579 9.41421 5.25 9 5.25C8.58579 5.25 8.25 5.58579 8.25 6V9C8.25 9.19891 8.32902 9.38968 8.46967 9.53033L10.3447 11.4053C10.6376 11.6982 11.1124 11.6982 11.4053 11.4053C11.6982 11.1124 11.6982 10.6376 11.4053 10.3447L9.75 8.68934V6Z"
      fill="currentColor"
    />
  </svg>
)

export default ClockFilled
